<div class="glass-card border border-danger-subtle bg-danger bg-opacity-10 p-3 rounded-4 shadow-sm mb-3">
    <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
        <div>
            <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
                <h4 class="fs-4 fw-bold mb-0">User Management</h4>
                <span class="badge rounded-pill text-bg-light border border-danger-subtle text-danger-emphasis">{{ users_count }} users</span>
                <span class="badge rounded-pill text-bg-success bg-opacity-25 border border-success border-opacity-25">{{ active_users_count }} active</span>
            </div>
            <p class="text-muted mb-0 text-sm">
                Add users, update their roles, and manage account access.
            </p>
        </div>

        <button
            type="button"
            class="btn btn-danger btn-sm rounded-3 d-inline-flex align-items-center gap-1 px-3 shadow-sm"
            @click="$emit('open-add-user')"
        >
            <i class="bi bi-person-plus-fill text-xs"></i>
            <span class="text-xs">Add user</span>
        </button>
    </div>
</div>
